module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('br'), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.start(_vm.fileHash)
      }
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Hash",
      "value": _vm.hash
    },
    model: {
      value: (_vm.fileHash),
      callback: function($$v) {
        _vm.fileHash = $$v
      },
      expression: "fileHash"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [(!_vm.loading) ? _c('span', [_vm._v("Get")]) : _vm._e(), _vm._v(" "), (_vm.loading) ? _c('i', {
    staticClass: "el-icon-loading"
  }) : _vm._e()])], 2)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-button', {
    attrs: {
      "disabled": _vm.loading,
      "type": "primary",
      "size": "medium"
    },
    on: {
      "click": function($event) {
        _vm.start(_vm.fileHash)
      }
    }
  }, [_vm._v(_vm._s(_vm.btnText))])], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('div', {
    staticClass: "progress"
  }, [_c('el-progress', {
    attrs: {
      "percentage": parseInt(_vm.downloadPercentage())
    }
  }), _vm._v(" "), (_vm.benchmarks) ? _c('el-row', {
    attrs: {
      "gutter": 0
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_vm._v(" Elapsed: " + _vm._s((_vm.elapsed())))]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_vm._v(" Received: " + _vm._s(_vm.downloadPercentage()) + "% (" + _vm._s(_vm.received()) + "/" + _vm._s(_vm.total()) + ")")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_vm._v(" Speed: " + _vm._s(_vm.rate()) + "/sec")])], 1) : _vm._e()], 1)])], 1), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.benchmarks && _vm.benchmarks.chunks.length > 0) ? _c('div', {
    staticClass: "chunks"
  }, [_c('h2', [_vm._v("Report")]), _vm._v(" "), _c('el-table', {
    staticClass: "report",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": [1],
      "stripe": "",
      "max-height": "500"
    }
  }, [_c('el-table-column', {
    attrs: {
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "metrics"
        }, [_c('div', [_vm._v("Hash ")]), _vm._v(" "), _c('div', [_vm._v("Total size")]), _vm._v(" "), _c('div', [_c('div', {
          staticStyle: {
            "visibility": "hidden"
          }
        }, [_vm._v(".")])]), _vm._v(" "), _c('div', [_vm._v("Received ")]), _vm._v(" "), _c('div', [_vm._v("Started ")]), _vm._v(" "), _c('div', [_vm._v("Finished ")]), _vm._v(" "), _c('div', [_vm._v("Duration ")]), _vm._v(" "), _c('div', [_c('strong', [_vm._v("Rates :")])]), _vm._v(" "), _c('div', [_vm._v("Min ")]), _vm._v(" "), _c('div', [_vm._v("Max ")]), _vm._v(" "), _c('div', [_vm._v("Average")]), _vm._v(" "), _c('div', [_vm._v("Median")])])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "metrics"
        }, [_c('div', [_vm._v(_vm._s(_vm.benchmarks.hash))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.prettyBytes(_vm.benchmarks.totalBytes)))]), _vm._v(" "), _c('div', [_c('div', {
          staticStyle: {
            "visibility": "hidden"
          }
        }, [_vm._v(".")])]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.prettyBytes(_vm.benchmarks.received)))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(new Date(_vm.benchmarks.started).toString()))]), _vm._v(" "), (_vm.benchmarks.finished) ? _c('div', [_vm._v(_vm._s(new Date(_vm.benchmarks.finished).toString()))]) : _c('div', [_vm._v(" running")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.elapsed()) + " ")]), _vm._v(" "), _c('div', [_c('div', {
          staticStyle: {
            "visibility": "hidden"
          }
        }, [_vm._v(".")])]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.prettyBytes(_vm.benchmarks.rates.min)) + "/sec")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.prettyBytes(_vm.benchmarks.rates.max)) + "/sec")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.prettyBytes(_vm.benchmarks.rates.avg)) + "/sec")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.prettyBytes(_vm.benchmarks.rates.median)) + "/sec")])])]
      }
    }])
  })], 1), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.benchmarks.chunks.length) + " Chunks")]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.benchmarks.chunks,
      "default-sort": {
        prop: 'time',
        order: 'ascending'
      },
      "stripe": "",
      "max-height": "500"
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "time",
      "label": "Arrived",
      "sortable": "",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', [_vm._v(_vm._s(new Date(scope.row.time).getHours()) + ":" + _vm._s(new Date(scope.row.time).getMinutes()) + ":" + _vm._s(new Date(scope.row.time).getSeconds()) + "." + _vm._s(new Date(scope.row.time).getMilliseconds()))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "bytes",
      "label": "Size",
      "sortable": "",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(_vm.prettyBytes(scope.row.bytes)) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "rate",
      "sortable": "",
      "label": "Speed"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm.prettyBytes(scope.row.rate)) + " /sec")])]
      }
    }])
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('br'), _c('br')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-62299d19","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Stream.vue
// module id = 912
// module chunks = 1